import { getMessageFactory } from "../getCaxaWebSocket.js";
const recordCaseChangedInfoSwitch = getMessageFactory({
  code: "RECORD_CASE_CHANGED_INFO_SWITCH"
});
export { recordCaseChangedInfoSwitch };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/recordCaseChangedInfoSwitch.js